import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useStore from "../../store";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CompareData = () => {
  const dataCompare = useStore((state) => state.dataCompare);
  const options = {
    chart: {
      style: {
        borderRadius: "10px",
      },
      // backgroundColor: "rgba(255,255,255, 0.05)",
    },
    accessibility: {
      enabled: false,
    },
    title: {
      text: "Compare Chart",
      // style: {
      //   color: "#ffffff",
      // },
    },
    xAxis: {
      type: "datetime",
      //   labels: {
      //     style: {
      //       color: "#ffffff",
      //     },
      //   },
    },
    // yAxis: {
    //   labels: {
    //     style: {
    //       color: "#ffffff",
    //     },
    //   },
    // },
    // legend: {
    //   itemStyle: {
    //     color: "#ffffff",
    //   },
    // },
    series: dataCompare,
  };
  return (
    <Box sx={{ mx: 10 }}>
      <Typography sx={{ fontSize: "2rem", marginBottom: "2rem" }}>
        Compare Data Page
      </Typography>
      <div className="chart-container">
        <Box sx={{ m: 2 }}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
      </div>
    </Box>
  );
};

export default CompareData;
